import Vue from 'vue'
import VueRouter from 'vue-router'
import Analytics from '@/views/Analytics'
const Update = () => import(/* webpackChunkName: "group-update" */ '@/views/Update')
const Api = () => import(/* webpackChunkName: "group-api" */ '@/views/Api')

Vue.use(VueRouter)

const routes = [
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics
  },
  {
    path: '/update',
    name: 'Update',
    component: Update
  },
  {
    path: '/api',
    name: 'Api',
    component: Api
  },
  {
    path: '*',
    redirect: { name: 'Analytics' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
